import { env } from '@/shared/config/env'

/**
 * Development-only diagnostics for catalog inconsistencies (orphans, unknown
 * categories, stale mapping ids). Never throws, silent in production.
 */
export const reportCatalogIssue = (
	kind: string,
	details: Record<string, unknown>
) => {
	if (env.NODE_ENV !== 'development') return
	console.warn(`[product-groups] ${kind}`, details)
}
